import React, {
    useState,
    useEffect
} from "react";

import axios from "axios";

import IgniteNavbar from "../../layout/IgniteNavbar";
import IgniteHeader from "../../layout/IgniteHeader";

import PerformanceGraphs
    from "../../../PerformanceGraphs";

import "./IgnitePerformance.css";


const IgnitePerformance = () => {

    /* ==============================
       HIDE WEBSITE NAVBAR / FOOTER
    ============================== */
 useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
    useEffect(() => {

        const navbar =
            document.querySelector(
                "header, .navbar"
            );

        const footer =
            document.querySelector(
                "footer"
            );

        if (navbar) {
            navbar.style.display = "none";
        }

        if (footer) {
            footer.style.display = "none";
        }

        return () => {

            if (navbar) {
                navbar.style.display = "";
            }

            if (footer) {
                footer.style.display = "";
            }

        };

    }, []);


    /* ==============================
       USER EMAIL
    ============================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* ==============================
       HISTORY
    ============================== */

    const [
        history,
        setHistory
    ] = useState({});


    /* ==============================
       LOADING
    ============================== */

    const [
        loading,
        setLoading
    ] = useState(true);


    /* ==============================
       FETCH PERFORMANCE HISTORY
    ============================== */

    useEffect(() => {

        if (!email) {

            setLoading(false);

            return;

        }


        const fetchHistory =
            async () => {

                try {

                    const res =
                        await axios.get(

                            `/api/admin/player-history/${email}`

                        );


                    setHistory(

                        res.data

                    );

                }

                catch (err) {

                    console.error(

                        "Performance History Error:",

                        err

                    );

                }

                finally {

                    setLoading(false);

                }

            };


        fetchHistory();

    }, [email]);


    /* ==============================
       UI
    ============================== */

    return (

        <div className="ignite-performance">

            {/* =========================
                SIDEBAR
            ========================= */}

            <IgniteNavbar />


            {/* =========================
                MAIN
            ========================= */}

            <main className="ignite-main">

                {/* =====================
                    HEADER
                ===================== */}

                <IgniteHeader

                    title="Performance"

                    subtitle={
                        "Track your progress. Analyze your performance. Keep improving."
                    }

                />


                {/* =====================
                    CONTENT
                ===================== */}

                {

                    loading

                    ?

                    (

                        <div className="ignite-loading">

                            Loading...

                        </div>

                    )

                    :

                    (

                        <PerformanceGraphs

                            history={history}

                        />

                    )

                }

            </main>

        </div>

    );

};


export default IgnitePerformance;
  